import { render, staticRenderFns } from "./MarginCalculatedOld.vue?vue&type=template&id=6a2e5019&scoped=true"
import script from "./MarginCalculatedOld.vue?vue&type=script&lang=js"
export * from "./MarginCalculatedOld.vue?vue&type=script&lang=js"
import style0 from "./MarginCalculatedOld.vue?vue&type=style&index=0&id=6a2e5019&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2e5019",
  null
  
)

export default component.exports